import React from 'react';
import { motion } from 'framer-motion';
import { SparklesIcon, CompassIcon, RepeatIcon, ClockIcon, ShieldIcon, SmileIcon, MapIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { CtaButton } from './CtaButton';
import { productPrice } from '../data/bonuses';
const items = [{
  icon: SparklesIcon,
  text: 'Herramientas para fortalecer tu autoestima desde la raíz.'
}, {
  icon: CompassIcon,
  text: 'Ejercicios de autoconocimiento y crecimiento personal.'
}, {
  icon: RepeatIcon,
  text: 'Estrategias para crear hábitos positivos que sí sostienes.'
}, {
  icon: ClockIcon,
  text: 'Técnicas para dejar de postergarte de una vez.'
}, {
  icon: ShieldIcon,
  text: 'Recursos para establecer límites saludables sin culpa.'
}, {
  icon: SmileIcon,
  text: 'Actividades para desarrollar una confianza real en ti misma.'
}, {
  icon: MapIcon,
  text: 'Un plan práctico para comenzar a elegirte cada día.'
}];
export function InsideList() {
  return <section className="w-full bg-sand py-20 sm:py-28" aria-labelledby="inside-title" data-id="element-108" data-mp="2sy6njftyi58w">
      <div className="mx-auto w-full max-w-5xl px-5 sm:px-8" data-id="element-109" data-mp="2wzih1wfybamd">
        <SectionHeading eyebrow="Lo que vas a encontrar dentro" title="Todo lo que nadie te enseñó sobre sostenerte a ti" data-id="element-110" data-mp="2wyyzigu7qo8v" />

        <ul className="mt-12 grid gap-4 sm:grid-cols-2" data-id="element-111" data-mp="2nykdtgdc774u">
          {items.map((item, index) => {
          const Icon = item.icon;
          return <motion.li key={item.text} initial={{
            opacity: 0,
            y: 16
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            amount: 0.4
          }} transition={{
            duration: 0.45,
            delay: index % 2 * 0.08
          }} className="flex items-start gap-4 rounded-2xl bg-cream p-6 shadow-[0_1px_0_rgba(74,43,61,0.06)]" data-id="element-112" data-mp="298mtxcmfx3lg" data-mpi={index}>
                <span className="mt-0.5 flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-blush/60" data-id="element-113" data-mp="1qdekaay1u1a7">
                  <Icon className="h-5 w-5 text-plum" aria-hidden="true" data-id="element-114" data-mp="1c59xn13rhsm7" />
                </span>
                <span className="text-base leading-relaxed text-ink/80" data-id="element-115" data-mp="17f3al5oweg62">{item.text}</span>
              </motion.li>;
        })}
        </ul>

        <CtaButton className="mt-12" label={`Empezar hoy por ${productPrice}`} sublabel="Y llévate los 6 bonos sin costo adicional" data-id="element-116" data-mp="12g8ex35u0x4j" />
      </div>
    </section>;
}